import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: "AIzaSyCpfFH0C6ex3cicMcZ9cdC92qVraoUn-TY",
  authDomain: "dandero-3dff1.firebaseapp.com",
  databaseURL: "https://dandero-3dff1-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "dandero-3dff1",
  storageBucket: "dandero-3dff1.firebasestorage.app",
  messagingSenderId: "885770013241",
  appId: "1:885770013241:web:96eefe541efd3f893adbe8",
  measurementId: "G-13L5HTGN11"
}

const app = initializeApp(firebaseConfig)
const db = getDatabase(app)

export { db }
